/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiMetricFromJSON, ApiMetricToJSON, } from './ApiMetric';
export function ApiIncrementalitySupportingMetricFromJSON(json) {
    return ApiIncrementalitySupportingMetricFromJSONTyped(json, false);
}
export function ApiIncrementalitySupportingMetricFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'incrementalityTestId': !exists(json, 'incrementalityTestId') ? undefined : json['incrementalityTestId'],
        'metric': !exists(json, 'metric') ? undefined : ApiMetricFromJSON(json['metric']),
    };
}
export function ApiIncrementalitySupportingMetricToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'incrementalityTestId': value.incrementalityTestId,
        'metric': ApiMetricToJSON(value.metric),
    };
}
